export function isUrl(v: string): boolean {
  const res = v.match(
    /[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&/=]*)/
  );
  return res !== null;
}
